import React from 'react';
import { Star, Play, Pause } from 'lucide-react';
import '../styles/CoverCard.css';

const CoverCard = ({
  cover,
  isPlaying,
  progressPct,
  onTogglePlay,
  onRate,
  audioRef,
  onTimeUpdate,
  onEnded,
  formatDate,
  toNum
}) => {
  const avgRating = toNum(cover.rating, 0);
  const votes = toNum(cover.votes, 0);
  const plays = toNum(cover.plays, 0); // ✅ NEW
  const dateLabel = formatDate(cover.date);

  return (
    <div className="cover-card">
      <h3>{cover.song}</h3>
      <p>by {cover.artist}</p>
      <p>Description: {cover.description}</p>
      <p className="cover-meta">
        {dateLabel ? `Uploaded ${dateLabel}` : 'Uploaded —'}
        {' • '}
        Avg {avgRating.toFixed(1)}
        {' • '}
        {votes} {votes === 1 ? 'vote' : 'votes'}
        {' • '}
        {plays} {plays === 1 ? 'play' : 'plays'} {/* ✅ NEW */}
      </p>

      <button onClick={() => onTogglePlay(cover.id)}>
        {isPlaying ? <Pause /> : <Play />}
      </button>

      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${progressPct || 0}%` }} />
      </div>

      <div className="star-rating">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onRate(cover.id, star);
            }}
          >
            <Star
              className={star <= Math.round(avgRating) ? 'star-filled' : 'star-empty'}
            />
          </button>
        ))}
      </div>

      <audio
        ref={audioRef}
        src={cover.audioUrl}
        onTimeUpdate={(e) => onTimeUpdate(cover.id, e)}
        onEnded={() => onEnded(cover.id)}
      />
    </div>
  );
};

export default CoverCard;
